// extracted by mini-css-extract-plugin
export default {"locationButton_card__label__d4cTJ":"modal_locationButton_card__label__d4cTJ__VUW0r","background":"modal_background__6cauh"};